import React, {useState,useEffect,} from "react";
import axios from "axios";
import { FiKey, FiShield } from "react-icons/fi";
import { parseAadhaarVerifyResponse } from "../../utils/aadhaarVerifyUtils";
import "./AadhaarInput.css";

const IconField = ({ icon: Icon, children, className = "" }) => (
  <div className={`loan-icon-field ${className}`.trim()}>
    <span className="loan-icon-field__icon" aria-hidden="true">
      <Icon />
    </span>
    {children}
  </div>
);

const AadhaarOtpStep1 = ({ onNext }) => {
  const [aadhaar, setAadhaar] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [aadhaarData, setAadhaarData] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [aadhaarError, setAadhaarError] = useState("");
const [retryTimer, setRetryTimer] = useState(0);
  const isAadhaarValid = /^\d{12}$/.test(aadhaar);
  const isFormValid = isAadhaarValid && consent;
  const isOtpValid = /^\d{6}$/.test(otp);
// TIMER EFFECT
useEffect(() => {
  let interval = null;

  if (retryTimer > 0) {
    interval = setInterval(() => {
      setRetryTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);
  }

  return () => {
    if (interval) {
      clearInterval(interval);
    }
  };
}, [retryTimer]);

  const getApiMessage = (data) =>
    data?.message || data?.responseMessage || data?.error || "";

  // Send OTP
  const sendOtp = async () => {
    if (!isFormValid) return;
    setLoading(true);
    setAadhaarError("");

    try {
      const API_URL =
        "https://fundswalla.in/loan_backend/sendAadhaarOtp.php";

      const payload = {
        aadhaar_number: aadhaar,
      };

      const res = await axios.post(API_URL, payload, {
        headers: { "Content-Type": "application/json" },
      });

      const responseData = res.data || {};
      const {
        success,
        responseCode,
        referenceId,
      } = responseData;

      const apiMessage = getApiMessage(responseData);

      if (success === false) {
        setAadhaarError(
          apiMessage || "Something went wrong."
        );
        return;
      }

      if (
        responseData.responseMessage === "Aadhar does not exist" ||
        responseCode === "EAE168"
      ) {
        setAadhaarError("Invalid Aadhaar number.");
        return;
      }

      const isOtpSent =
        success === true ||
        referenceId ||
        apiMessage.toLowerCase().includes("otp");

      if (!isOtpSent) {
        setAadhaarError(
          apiMessage || "Something went wrong."
        );
        return;
      }

      localStorage.setItem("aadhaarNumber", aadhaar);
      localStorage.setItem(
        "aadhaarReferenceId",
        referenceId || ""
      );

      if (apiMessage) {
        setAadhaarError(apiMessage);
      }

      const match = apiMessage.match(/\d+/);
      if (match && match[0]) {
        setRetryTimer(parseInt(match[0], 10));
      }

      setOtpSent(true);
    } catch (err) {
      const errorMessage =
        getApiMessage(err?.response?.data) ||
        "OTP failed. Please try again.";
      setAadhaarError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP
  const verifyOtp = async () => {
    if (!otp) {
      setOtpError("Please enter the OTP sent to your mobile.");
      return;
    }

    setOtpLoading(true);
    setOtpError(""); // Clear previous errors
    try {
      const backendUrl = "https://fundswalla.in/loan_backend/verifyAadhaarOtp.php";

      const payload = {
        aadhaar_number: localStorage.getItem("aadhaarNumber"),
        otp: otp,
        referenceId: localStorage.getItem("aadhaarReferenceId")
      };

      console.log("VERIFY PAYLOAD:", payload);

      const res = await axios.post(backendUrl, payload);
      console.log("VERIFY RESPONSE:", res.data);

      console.log("Full Response Structure:", JSON.stringify(res.data, null, 2));

      const parsed = parseAadhaarVerifyResponse(res.data);
      const isSuccess =
        parsed.responseCode === "SRC001" &&
        parsed.profile &&
        Object.keys(parsed.profile).length > 0;

      const responseMessage = String(parsed.responseMessage || "").toLowerCase();
      const isFailure =
        parsed.responseCode === "EAE168" ||
        responseMessage.includes("invalid") ||
        responseMessage.includes("incorrect") ||
        responseMessage.includes("failed");

      console.log("Success check:", isSuccess, "Failure check:", isFailure);

      if (isSuccess) {
        setVerified(true);
        setAadhaarData(parsed.profile);

        localStorage.setItem("aadhaarData", JSON.stringify(parsed.profile));

        if (parsed.mobile) {
          localStorage.setItem("aadhaar_mobile", parsed.mobile);
        } else {
          localStorage.removeItem("aadhaar_mobile");
        }
        
        setTimeout(() => {
          onNext();
        }, 500);
      } else if (isFailure) {
        console.log("Verification failed. Response:", res.data);
        const errorMsg = res.data?.data?.responseMessage || 
                         res.data?.message || 
                         res.data?.error || 
                         "Incorrect OTP. Please try again.";
        setOtpError(errorMsg);
      } else {
        // If neither success nor failure conditions match, treat as failure
        console.log("Unknown response, treating as failure. Response:", res.data);
        const errorMsg = res.data?.data?.responseMessage || 
                         res.data?.message || 
                         res.data?.error || 
                         "OTP verification failed. Please try again.";
        setOtpError(errorMsg);
      }
    } catch (err) {
      console.error(err);
      setOtpError("OTP verification failed. Please check your internet connection and try again.");
    }
    setOtpLoading(false);
  };

  if (verified) {
    return (
      <div className="apply-form-head" style={{ textAlign: "center", border: "none" }}>
        <h2>{"\u2705"} Verified!</h2>
        <p>Redirecting...</p>
      </div>
    );
  }

  return (
    <div className="apply-now1-focus">
      <div className="apply-now1-focus-card">
        <div className="apply-form-head">
          <div className="apply-now1-hero">
            <span className="apply-now1-hero__eyebrow">Start Application</span>
            <h2>Verify with Aadhaar</h2>
            <p>Enter Aadhaar to begin your loan journey and confirm the OTP below.</p>
          </div>
        </div>

        <>
          <div className="apply-field">
            <label>Aadhaar Number <span className="req">*</span></label>
            <IconField icon={FiShield}>
              <input
                maxLength={12}
                value={aadhaar}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setAadhaar(e.target.value);
                    setAadhaarError("");
                  }
                }}
                placeholder="XXXX XXXX XXXX"
                disabled={otpSent}
                className={`apply-flow-input ${isAadhaarValid ? "valid" : ""} ${aadhaarError && !aadhaarError.toLowerCase().includes("sent") ? "error" : ""}`}
              />
            </IconField>
            {aadhaarError && (
              <div className={aadhaarError.toLowerCase().includes("sent") ? "apply-flow-success" : "apply-flow-error"}>
                {aadhaarError}
              </div>
            )}
          </div>

          <div className="apply-flow-consent">
            <input
              type="checkbox"
              checked={consent}
              onChange={() => setConsent(!consent)}
              disabled={otpSent}
            />
            <label>
              I authorize <b>Aadhaar verification</b> and <b>digital communications</b>.
            </label>
          </div>

          {!otpSent && (
            <div className="apply-flow-actions apply-flow-actions--inline">
              <button
                className="apply-flow-btn apply-flow-btn--primary"
                disabled={!isFormValid || loading}
                onClick={sendOtp}
              >
                {loading ? "Sending..." : "Get OTP"}
              </button>
            </div>
          )}

          {otpSent && (
            <div className="apply-now1-otp-panel">
              <div className="apply-field">
                <label>OTP <span className="req">*</span></label>
                <IconField icon={FiKey}>
                  <input
                    type="text"
                    maxLength={6}
                    value={otp}
                    placeholder="6-digit OTP"
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setOtp(e.target.value);
                        setOtpError("");
                      }
                    }}
                    className={`apply-flow-input ${isOtpValid ? "valid" : ""} ${otpError ? "error" : ""}`}
                  />
                </IconField>
                {otpError && <div className="apply-flow-error">{otpError}</div>}
              </div>

              <p className="apply-now1-entry__resend">
                {retryTimer > 0 ? (
                  <span>Resend in {retryTimer}s</span>
                ) : (
                  <button type="button" className="apply-now1-entry__link" onClick={sendOtp}>
                    Resend OTP
                  </button>
                )}
              </p>

              <div className="apply-flow-actions apply-flow-actions--inline">
                <button
                  className="apply-flow-btn apply-flow-btn--secondary"
                  onClick={() => { setOtpSent(false); setOtp(""); setAadhaar(""); setConsent(false); }}
                  disabled={otpLoading}
                >
                  Back
                </button>
                <button
                  className="apply-flow-btn apply-flow-btn--primary"
                  disabled={!isOtpValid || otpLoading}
                  onClick={verifyOtp}
                >
                  {otpLoading ? "Verifying..." : "Verify"}
                </button>
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default AadhaarOtpStep1;
